import { EvaluateTemplate } from '@/ux-common/src/types/api';

/**
 * Filters out evaluation templates that belong to the 'test' category.
 * @param templates The array of evaluation templates to filter.
 * @returns The filtered array of evaluation templates, excluding those with the 'test' category.
 */
export const filterEvalTemplates = (
  templates?: EvaluateTemplate[] | null
): EvaluateTemplate[] => {
  const rawTemplates = templates ?? [];
  return rawTemplates.filter((template) => {
    const category = template?.category;
    if (Array.isArray(category)) {
      return !category.includes('test');
    }
    if (typeof category === 'string') {
      return category !== 'test';
    }
    return true;
  });
};

/**
 * Retrieves the label enums for a specific evaluation template by its name.
 * @param evalTemplates The array of evaluation templates to search within.
 * @param evalName The name of the evaluation template to find.
 * @returns The array of label enums for the matching evaluation template, excluding 'not_evaluated'.
 */
export const getTemplateLabelEnums = (
  evalTemplates: EvaluateTemplate[] | null | undefined,
  evalName?: string
): string[] => {
  if (!evalName || !Array.isArray(evalTemplates)) {
    return [];
  }

  const matchingTemplate = evalTemplates.find(
    (template) => template.name === evalName
  );

  const enums = matchingTemplate?.eval_result_schema?.label?.enums;
  return Array.isArray(enums)
    ? enums.filter((value) => value !== 'not_evaluated')
    : [];
};
